import type { CompanyQuota, DataCreditsStateDto } from '../../domain/quota';
import type { ExportQuota } from '../../domain/user';
import { BASE_API_URL, HttpClient } from '../../services/HttpClient';

export const quotaApi = {
  getDataCredits: async (): Promise<DataCreditsStateDto> => {
    return HttpClient.get<DataCreditsStateDto>(`${BASE_API_URL}/data-credits/state`);
  },

  notifyAdminForQuota: async (): Promise<void> => {
    return HttpClient.post(`${BASE_API_URL}/data-credits/notify-admin`, undefined);
  },

  getCompanyQuota: async (signal?: AbortSignal): Promise<CompanyQuota> => {
    return HttpClient.get<CompanyQuota>(`${BASE_API_URL}/company/quota`, { signal });
  },

  /* Legacy endpoint for packages v < 4 */
  getExportQuota: async (signal?: AbortSignal): Promise<ExportQuota> => {
    return HttpClient.get<ExportQuota>(`${BASE_API_URL}/export/quota`, {
      signal,
    });
  },
};

export default quotaApi;
